import { Component, inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from '@shared/service/shared.service';
import { CourseService } from '@shared/service/course.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CrossTabCommunication, RxjsSubscription, TabletApp, TokenService } from '@common';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

/**
 * 应用根组件
 *
 * @since 1.0
 * @version 1.0
 */
@Component({
  selector: 'fl-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  rxjsSubs: RxjsSubscription = new RxjsSubscription();

  private sharedSrv: SharedService = inject(SharedService);
  private courseSrv: CourseService = inject(CourseService);
  private tokenService: TokenService = inject(TokenService);
  private modalService: NzModalService = inject(NzModalService);
  private drawerService: NzDrawerService = inject(NzDrawerService);
  private zone: NgZone = inject(NgZone);

  constructor() {
    TabletApp.initial(this.zone, this.modalService, this.drawerService);
  }

  async ngOnInit() {
    this.initTokenService();

    // 清除跨页签数据 > 1h
    CrossTabCommunication.cleanupExpiredData();

    // 获取学科列表
    if (this.sharedSrv.user) {
      const subjectList = await this.courseSrv.getSubjectList();
      this.sharedSrv.prepareSubjectMaps(subjectList);
    }

    /**
     * 浏览器版本过低给提示
     */
    if (this.sharedSrv.isChrome90()) {
      window.alert('您的浏览器版本过低，可能导致部分功能异常，请更新或安装新的浏览器。');
    }
  }

  ngOnDestroy() {
    this.rxjsSubs.unsubscribe();
    // 销毁token检查
    this.tokenService.destroy();
  }

  initTokenService() {
    // 初始化token检查
    const excludesUrls = [
      '/paper/question/refer/group/node',
      new RegExp(/\/preview\/(\d+)\/chapter/),
      '/preview/task/detail/',
      '/video-question/refer-node',
      '/exception',
      '/tk/paper/',
      /^\/tk\/question\/\d+$/i,
      new RegExp(/course\/(\d+)\/chapter\/(\d+)\/knowledgeModule\/(\d+)/),
    ];
    this.tokenService.init(excludesUrls);
    this.rxjsSubs.subscriptions = this.tokenService.tokenExpired$.subscribe(() => {
      this.sharedSrv.clearAll();
    });
  }
}
